import segments from '../assets/release-2026-10-27/planungsbedarf-01-bereiche.png'
import material from '../assets/release-2026-10-27/planungsbedarf-02-material-bestellt.png'
import { makeBox, type GuideStepContent } from './guideStep'

/** Window screenshots, 2033×1162; measured on their 2000×1143 preview, which gives the same percentages. */
const box = makeBox(2000, 1143)

export const PLANUNGSBEDARF_INTRO =
  'Unter „Planungsbedarf“ stehen alle Termine, die neu oder weiter geplant werden müssen.'

export const PLANUNGSBEDARF_STEPS: GuideStepContent[] = [
  {
    title: 'Vier Bereiche',
    text: 'Oben wählen Sie: „Alle“, „Umdisponieren“ (z. B. bei Krankheit oder Urlaub des Handwerkers), „Folgetermin“ und „Material bestellt“. Die Zahl zeigt, wie viele Einträge es gibt.',
    image: segments,
    imageAlt: 'Seite „Planungsbedarf“ mit den vier Bereichen oben',
    focus: [box(384, 306, 940, 346)],
    wide: true,
  },
  {
    title: '„Material bestellt“',
    text: 'Diesen Grund wählt der Handwerker, wenn er einen Folgetermin meldet, weil Material fehlt. Der Eintrag wartet dann 14 Tage, bis dahin steht „fällig ab …“ dabei. Danach wird er rot, z. B. „seit 20 Tagen · fällig“, und das Büro bekommt eine Push-Nachricht. Oben bei „Material bestellt“ steht, wie viele fällig sind.',
    image: material,
    imageAlt: 'Bereich „Material bestellt“ mit fälligen und wartenden Einträgen',
    focus: [box(882, 314, 930, 338), box(1618, 462, 1742, 498), box(1618, 910, 1722, 946)],
    wide: true,
  },
]
